export const COLOR = {
  neutral: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#e5e5e5',
    300: '#d4d4d4',
    400: '#a3a3a3',
    500: '#737373',
    600: '#525252',
    700: '#404040',
    800: '#262626',
    900: '#171717',
    950: '#0a0a0a'
  },
  gray: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#e5e7eb',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827',
    950: '#030712'
  },
  accent: {
    green: '#23C666',
    warning: '#FFB031',
    danger: '#FC1D1D',
    blue: '#2C8DFF',
    offline: 'rgba(160, 160, 160, 0.9)'
  },
  background: {
    green: 'rgba(45, 249, 147, 0.26)',
    warning: 'rgba(255, 175, 78, 0.26)',
    danger: 'rgba(255, 99, 78, 0.26)',
    blue: 'rgba(44, 141, 255, 0.26)',
    offline: 'rgba(150, 150, 150, 0.36)',
    screen: '#F7F7F7'
  },
  backgroundOutline: {
    green: 'rgba(45, 249, 147, 0.1)',
    warning: 'rgba(255, 175, 78, 0.1)',
    danger: 'rgba(255, 99, 78, 0.1)',
    blue: 'rgba(44, 141, 255, 0.1)',
    offline: 'rgba(150, 150, 150, 0.1)'
  },
  black: "#000000",
  white: "#ffffff",
  graph: {
    green: '#78de9c',
    blue: '#5290f3',
    red: '#e25865',
    orange: '#ecb244'
  },
  lightGray: '#F2F2F2',
  cleaningMain: "#DAF4FB",
  deliveryMain: "#DAFBEF"
}

export const randomColorArray = [
  '#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6',
  '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
  '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
  '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
  '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
  '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
  '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680',
  '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
  '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
  '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'
]